import React from 'react';

import './index.css';

function InnerPageLayout({children}) {
	return (
		<div className="page-layout">
			{children}
		</div>
	);
}

export default InnerPageLayout;



// WEBPACK FOOTER //
// ./src/layouts/inner-page-layout.jsx